export const headersTiposDominio = [
  { text: '', width: 1, key: 'offCanvas' },
  { text: 'ID', width: 2, key: 'id' },
  { text: 'Status', width: 5, key: 'status' },
  { text: 'Ordem', width: 4, key: 'ordem' },
  { text: 'Nome do Tipo', width: 12, key: 'nome' },
  { text: 'Descrição', width: 20, key: 'descricao' },
];

export const valoresExibidosDominiosTipos: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Data de Registro',
  dataAtualizacao: 'Última Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  dataUltimaAtualizacao: 'Última Atualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  usuarioRegistro: 'Responsável pelo Registro',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  observacoes: 'Observações',

  // Domínio Tipo
  status: 'Status',
  ordem: 'Ordem',
  nome: 'Nome do Tipo',
  descricao: 'Descrição',
  corId: 'ID da Cor',
  corCodigo: 'Código da Cor',
  corNome: 'Nome da Cor',
  corText: 'Cor do Texto',

  //Separadores
  separador: '',
  separadorLog: '',
  separadorCores: '',
  separadorSubtipos: '',
  separadorObservacoes: '',
};

export const fieldObject = [
  'usuarioRegistro.nomeCompleto',
  'usuarioAtualizacao.nomeCompleto',
  'usuarioUltimaVisualizacao.nomeCompleto',
];
